import React from 'react';

import { FormStatus, SelectionMode, EntryListingMode, WorkflowStep } from 'model/dictionary';

import EntriesPage from 'components/EntriesPage';

export default function Voting() {

	return (
		<EntriesPage
			title="Votación"
			description="Acá el jurado vota a los finalistas de los premios que tiene asignados. Elija un premio, revise cada postulación desde el detalle o el PDF y vote la que considere ganadora. Hay un voto por premio: si después vota otra, el voto anterior se reemplaza. La postulación votada queda primera en la lista."
			workflowStep={WorkflowStep.VOTING}
			entryListMode={EntryListingMode.VOTING}
			formStatusFiltered={FormStatus.FINALIST}
			selectionMode={SelectionMode.SIMPLE}
		/>
	);

}
